"use client";

import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import React, { useRef } from "react";
import { MultiDietDoubtsAvatar } from "@/features/static-builder/components/multidiet-doubts/multidiet-doubts-avatar";
import type { MultidietDoubtsType } from "@/features/static-builder/types/multidiet-doubts.type";

export const MultiDietDoubtsList = ({
  data,
  url,
}: {
  data: MultidietDoubtsType;
  url: string;
}) => {
  const avatarRef = useRef<HTMLDivElement | null>(null);

  useGSAP(() => {
    const avatar = avatarRef.current;
    gsap.fromTo(
      avatar,
      { x: -100, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 0.2,
        ease: "circ.inOut",
        scrollTrigger: {
          trigger: "#mobile-doubts-container",
          start: "top 80%",
        },
      },
    );
  }, []);
  return (
    <div
      id="mobile-doubts-container"
      className="relative mt-6 flex flex-col gap-5 overflow-hidden lg:hidden"
    >
      <div ref={avatarRef} className="absolute top-0 left-0">
        <MultiDietDoubtsAvatar avatar={data.avatar} url={url} />
      </div>
      {data.doubts.slice(0, 5).map((item) => (
        <div
          key={item.id}
          className="w-[83%] rounded-2xl border border-brand-grey2 p-4 even:self-end"
        >
          <p className="text-brand-green2-300 leading-6">{item.label}</p>
        </div>
      ))}
    </div>
  );
};
